@if (contributionsLength > 0 && (isMarketOpen === true || allowSubmission === true)) {
  <div [@slider]="contributionsLength > 0 && (isMarketOpen === true || allowSubmission === true)? 'show' : 'hide'" class="slider scrollableTable mat-elevation-z6 mt-3">
    <table  mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="contributor">
        <th mat-header-cell *matHeaderCellDef style="width: 35%;"> {{'Summary.thContributor' | translate}}</th>
        <td mat-cell *matCellDef="let element">{{element.contributor}}</td>
      </ng-container>
      <ng-container matColumnDef="contributed">
        <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'Summary.thContributed' | translate}}</th>
        <td mat-cell *matCellDef="let element">{{element.contributed | date:"mediumTime"}}</td>
      </ng-container>
      <ng-container matColumnDef="assessor">
        <th mat-header-cell *matHeaderCellDef style="width: 35%;"> {{'Summary.thAssessor' | translate}}</th>
        <td mat-cell *matCellDef="let element">{{element.assessor}}</td>
      </ng-container>
      <ng-container matColumnDef="assessed">
        <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'Summary.thAssessed' | translate}}</th>
        <td mat-cell *matCellDef="let element">{{element.assessed | date:"mediumTime"}}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'Summary.thStatus' | translate}}</th>
        <td mat-cell *matCellDef="let element">{{element.status}}</td>
      </ng-container>
      <ng-container matColumnDef="loading">
        <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'tblLoading' | translate}}... </th>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSource!=null}"></tr>
    </table>
  </div>
}
